import React, { useState } from 'react'
import { endpoint } from '../../../../common/constant';
import { Dialog, Box, DialogContent, Tooltip } from '@mui/material';
import { fetchAllPromisedData } from '../../../../common/utils/methods/commonMethods/utilityMethod';
import { getFormatedDate } from '../../../../unAssigned/concessionApproval/common';
import { ReactComponent as UserProfile } from "../../../../../../../assets/img/svg/userProfile.svg";
import closeIcon from "../../../../../../../assets/img/svg/closeSquare.svg";
import styles from './styles.module.scss';
import CustomLoader from '../../../../common/commonComponents/Loader/loader';
import { UserNameByUserId } from './utils';


const ViewHistory = ({ buId }) => {

    const [historyData, setHistoryData] = useState({ fetching: false, data: [] });
    const [historyDialogOpen, setHistoryDialogOpen] = useState(false);

    const fetchHistoryData = async () => {

        try {
            setHistoryDialogOpen(true);
            setHistoryData({ fetching: true, data: [] });
            const resp = await fetchAllPromisedData(`${endpoint?.featureSetup?.getFeatureAuditHistory}/${buId}`);
            setHistoryData({ fetching: false, data: resp });

        } catch (err) {
            console.error(err);
            setHistoryData({ fetching: false, data: [] });
        }
    }

    return (
        <>
            <button
                className={styles.history_btn}
                onClick={fetchHistoryData}
            >
                History
            </button>

            <Dialog
                open={historyDialogOpen}
            >

                <DialogContent style={{ padding: '0px', overflowX: 'hidden' }} >

                    <Box className='concession-approval-dialog-content' width={450}>

                        <Box className='approval-dialog-header'>
                            <div style={{ fontWeight: 600, fontSize: '20px' }}>History</div>
                            <div onClick={() => setHistoryDialogOpen(false)}><img src={closeIcon} /></div>
                        </Box>

                        {historyData?.fetching && <CustomLoader />}

                        {!historyData?.fetching && historyData?.data?.map(el => {
                            return (
                                <Box className='user-remarks-details d-flex'>

                                    <UserProfile style={{ flexShrink: 0, marginRight: '3px' }} />

                                    <Box className='user-remarks'>
                                        <div className={styles.history_popup_h1}>Features {el?.status === 'ACTIVE' ? 'Activated' : 'Deactivated'}</div>
                                        <div className={styles.history_popup_h2}>
                                            <Tooltip title={<UserNameByUserId userId={el?.updatedBy} placement="top"/>}>
                                                <span>{el?.updatedBy},</span>
                                            </Tooltip>
                                            <span>Ticket Ref : {el?.ticketNumber}</span>
                                        </div>
                                        <div className={styles.history_popup_h3}>
                                            {`${el.updatedBy} | ${getFormatedDate(el?.updatedOn, true)}`}
                                        </div>

                                    </Box>

                                </Box>)
                        })}

                    </Box>
                </DialogContent>
            </Dialog>
        </>
    );
}

export default ViewHistory;